import React from 'react';
const links = [{
  label: 'Terms',
  href: '#terms'
}, {
  label: 'Privacy',
  href: '#privacy'
}, {
  label: 'Refunds',
  href: '#refund'
}, {
  label: 'Contact',
  href: '#contact'
}];
export function SiteFooter() {
  return <footer className="border-t border-brand-ivory/10 bg-brand-charcoal px-5 py-12 text-brand-ivory/70 lg:px-8" data-id="element-147" data-mp="35diwwaycgflo">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-148" data-mp="3a6c0gvi2thw6">
        <p className="font-body text-[13px] font-semibold uppercase tracking-[0.22em] text-brand-ivory" data-id="element-149" data-mp="3f685my2iffdb">
          Lash &amp; Brow Instructor Ready™
        </p>
        <nav aria-label="Footer" className="flex flex-wrap gap-x-7 gap-y-2 font-body text-[13px]" data-id="element-150" data-mp="3o5v7tm32cp7f">
          {links.map(link => <a key={link.label} href={link.href} className="underline-offset-4 transition-colors duration-200 ease-out hover:text-brand-ivory hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-ivory/60" data-id="element-151" data-mp="3t33qdns4iv97">
              {link.label}
            </a>)}
        </nav>
      </div>
      <p className="mx-auto mt-8 max-w-6xl font-body text-[12px] leading-relaxed text-brand-ivory/55" data-id="element-152" data-mp="oafke8ol7rs">
        © 2026 Lash &amp; Brow Instructor Ready™ by Prof. Kyra. Digital teaching resources for lash and brow
        instructors and beauty educators. Does not replace professional technical training and does not provide
        official certification, accreditation or licensing. Secure checkout — payment processed in your local
        currency.
      </p>
    </footer>;
}